import {
  DeviceConfigParser,
  IotizeConfigModel,
} from '@iotize/tap/config/iotize-studio';
import { parseString as parseAsync } from 'xml2js';

// TODO remove xml2js dependencie

/**
 * Convert XML to Javascript Object
 */
export class XMLParser implements DeviceConfigParser {
  /**
   * Parse XML input synchonously
   * @param xml
   */
  parseSync(xml: string): any {
    let res: any = null;
    parseAsync(xml, function (err: any, result: any) {
      if (err !== null) {
        throw err;
      }
      res = result;
    });
    return res;
  }

  /**
   * Parse XML input async
   * @param xml
   */
  parse(xml: string): Promise<IotizeConfigModel> {
    xml = this.cleanifyXml(xml);
    return new Promise<any>((resolve, reject) => {
      parseAsync(xml, function (err: any, result: any) {
        if (err !== null) {
          reject(err);
        }
        resolve(result);
      });
    });
  }

  /**
   * Cleanify the xml input before parsing
   * @see http://stackoverflow.com/questions/34783452/cannot-parse-xml-error-non-whitespace-before-first-tag-line-0-column-1-cha
   */
  cleanifyXml(xml: string): string {
    if (!xml) {
      return xml;
    }
    return xml.replace('\ufeff', '').trim();
  }
}
